import { Component, OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { ActivatedRoute } from '@angular/router';

import { TranService, PrInTransaction, TranType } from '../../services/tran.service';
import { WarehouseService } from '../../services/warehouse.service';
import { InAndOutService } from '../../services/in-and-out.service';
import { ProductCmpaService } from '../../services/product-cmpa.service';
import { ProductVntaService } from '../../services/product-vnta.service';

import { Observable } from 'rxjs/Observable';
import { Utils } from '../../util';
import { JsonPipe } from '@angular/common/src/pipes';
import { Subscription } from 'rxjs';
import { ProductionOrderService } from '../../services/production-order.service';
import { CatalogsSettingsService, Folios, PayrollId } from '../../services/catalogs-settings.service';
import { PurchaseOrderId, PurchaseOrderService } from '../../services/purchase-order.service';
import { CustomerBillService, CustomerBillId, CustomerBillData } from '../../services/customer-bill.service';
import { RemissionService, RemissionId } from '../../services/remission.service';
import { UnitService, UnitId } from '../../services/unit.service';
import { SelectOption } from '../../globals';

@Component({
  selector: 'app-create-in-tran',
  templateUrl: './create-in-tran.component.html',
  styleUrls: ['./create-in-tran.component.css']
})

export class CreateInTranComponent implements OnInit, OnDestroy {

  //nextFolio: string = '';
  //requestedFolio: number;
  settings: PayrollId;
  transactions = {};
  transactionError: boolean = false;

  //Store the warehouse name and id
  warehouse: any = {
    id: '',
    name: ''
  };

  //Store data for autocomplete inputs
  productsInit: any;
  inOutTypes = {};
  inOutTypesInit: any;
  prCmpas = {};
  prCmpasInit: any;
  prVntas = {};
  prVntasInit: any;

  unitsById: {[id: string]: UnitId} = {};

  allProducts = {};

  prCmpaFixId: string = '';
  prCmpaFixSelect: SelectOption[] = [];

  productType: string = 'compra';

  warehouse$: Observable<any>;

  //Forms
  createInTranForm: FormGroup;//Main form for create
  tranProductForm: FormGroup;//Form for product modal

  modalActionsTranProduct = new EventEmitter<string|MaterializeAction>();
  modalParamsTranProduct = [{dismissible: true}];
  onEdit: number = -1;
  productsInTransaction: PrInTransaction[] = [];
  productError: boolean = false;
  
  pickadateParams = Utils.pickadateParams();

  subs: Subscription[] = [];
  odcSub: Subscription;

  constructor(
    private tranService: TranService,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,

    private warehouseService: WarehouseService,
    private inAndOutService: InAndOutService,
    private productCmpaService: ProductCmpaService,
    private unitService: UnitService,
    private productVntaService: ProductVntaService,
    private productionOrderService: ProductionOrderService,
    private odcService: PurchaseOrderService,
    private billService: CustomerBillService,
    private billData: CustomerBillData,
    private remService: RemissionService,
    private settingsService: CatalogsSettingsService,
  ) {
    //Assign folio
    /* let setSub = this.settingsService.getPayrollSettings('1').subscribe(settings => {
      let requesteds = settings.folios.nextInRequesteds || [];
      let lastFolio = settings.folios.nextIn;
      this.settings = settings;
      if(!this.requestedFolio){
        this.requestedFolio = lastFolio + 1;
        while(requesteds.includes(this.requestedFolio)) this.requestedFolio++;
        this.nextFolio = `E${Utils.String.fillLeft(`${this.requestedFolio}`, '0', 6)}`;
        toast(`Se apartó el folio '${this.requestedFolio}' de configuración.`, 2000);
        console.log(`Se apartó el folio '${this.requestedFolio}' de configuración.`);
        requesteds.push(this.requestedFolio);
        settings.folios.nextInRequesteds = requesteds;
        this.settingsService.putPayrollSettings(<PayrollId>{folios: settings.folios}, '1');
      }
    });
    this.subs.push(setSub); */

    //Get name of the warehouse using the id in the URL
    this.warehouse.id = this.activatedRoute.snapshot.paramMap.get('idWare');
    this.warehouse$ = this.warehouseService.getWarehouse(this.warehouse.id);
    let subWare = this.warehouse$.subscribe(warehouse => {
      this.warehouse.name = warehouse.name;
      subWare.unsubscribe();
    });

    this.productionOrders = {};
    this.subs.push(
      this.productionOrderService.getProductionOrders().subscribe(productionOrders => {
        this.rowsRead[0] = productionOrders.map(({id$, ...productionOrder}) => {
          return this.productionOrders[id$] = {id: id$, ...productionOrder}; 
        });
      })
    );

  }

  ngOnInit() {
    this.createForm();
    this.createTranProductForm();
    //Rerive data for autocomplete | InAndOut, only In
    this.subs.push(
      this.inAndOutService.getInAndOuts('in').subscribe(inOutTypes => {
        const data = inOutTypes.reduce((acc, cur) => {
          acc[`${cur.description.trim()}`] = null;
          this.inOutTypes[`${cur.description.trim()}`] = cur.id;
          return acc;
        }, {});
        this.inOutTypesInit = { 'data': data };
      })
    );
    //Rerive data for autocomplete | bill
    this.subs.push(
      this.billService.getCustomerBills().subscribe(bills => {
        //console.log('Got bills.', bills);
        this.rowsRead[2] = bills.map(bill => {
          bill.name = bill.folio;
          bill.customerName = bill.customerObj.name;
          bill.statusName = this.billData.status[status];
          this.bills[bill.id] = bill;
          return bill;
        });
      })
    );
    //Rerive data for autocomplete | rem
    this.subs.push(
      this.remService.getRemissions().subscribe(rems => {
        //console.log('Got rems.', rems);
        this.rowsRead[3] = rems.map(rem => {
          rem.name = rem.folio;
          rem.odp = (rem.productionOrder || {folio: ''}).folio;
          rem.businessName = rem.fiscalDataObj.businessName;
          rem.addressName = `${rem.addressObj.street}, #${rem.addressObj.externalNumber}`;
          this.rems[rem.id] = rem;
          return rem;
        });
      })
    );
    //Rerive data for autocomplete | productCmpa
    let unitSub = this.unitService.getUnits().subscribe(units => {
      unitSub.unsubscribe();
      this.unitsById  = units.reduce((acc, cur) => ({...acc, [cur.id]: cur}), {});
      this.subs.push(
        this.productCmpaService.getPrCmpas().subscribe(prCmpas => {
          this.prCmpaFixSelect = [
            {name: 'Seleccione un producto', value: ''},
          ]
          const data = prCmpas.reduce((acc, cur) => {
            let characs = cur.characs.reduce((acc2, cur2, index) => `${acc2}${index ? ', ' : ''}${cur2.name.charAt(0)} ${cur2.value}`, '');
            let unitName = cur.unitRef && this.unitsById[cur.unitRef.id] && this.unitsById[cur.unitRef.id].name || '';
            cur.fullName = `${cur.name}${characs ? ` - ${characs}` : ''} - ${cur.code}${unitName ? ` - ${unitName}` : ''}`.trim();
            acc[cur.fullName] = null;
            this.allProducts[cur.id] = {...cur};
            this.prCmpas[cur.fullName] = cur.id;
            this.prCmpaFixSelect.push({name: cur.fullName, value: cur.id});
            return acc;
          }, {});
          this.prCmpaFixSelect.sort((op1, op2) => op1.name > op2.name ? 1 : -1 );
          this.prCmpasInit = { "data": data };
          this.odcs = {};
          if(this.odcSub) this.odcSub.unsubscribe();
          this.odcSub = this.odcService.getPurchaseOrders().subscribe(odcs => {
            this.rowsRead[1] = odcs.map(odc => {
              if(odc.prForOrders.every(pr => pr.quantity - (pr.inWareQuantity || 0) <= 0)) return null;
              odc.prForOrders.map(pr => {
                if(this.prCmpas[pr.name]){
                  pr.id = pr.id || this.prCmpas[pr.name];
                }
              });
              odc.name = odc.folio;
              odc.supplierName = odc.supplierObj.name;
              odc.odpNames = odc.prForOrders.map(({odpName=''}) => odpName).filter(d => d).join(', ');
              this.odcs[odc.id] = odc;
              return odc;
            }).filter(notNull => !!notNull);
          })
        })
      );
    })
    //Rerive data for autocomplete | productVnta
    this.subs.push(
      this.productVntaService.getPrVntas().subscribe(prVntas => {
        const data = prVntas.reduce((acc, cur) => {
          acc[`${cur.name} - ${cur.code}`.trim()] = null;
          this.allProducts[cur.id] = {...cur};
          this.prVntas[`${cur.name} - ${cur.code}`.trim()] = cur.id;
          return acc;
        }, {});
        this.prVntasInit = { "data": data };
      })
    );
  }
  ngOnDestroy(){
    this.subs.map((sub, index) => {
      this.subs[index].unsubscribe();
    });
  }

  async onSubmit({ value } : { value: any }) {
    if(this.inOutTypes[value.inOutType] == undefined){
      this.transactionError = true;
      this.createInTranForm.get('inOutType').reset();

    }else{
      let tran = {...value};
      if(tran.inOutType.toLowerCase().includes('ajuste') && !tran.observations) return toast('Un ajuste debe llevar observaciones.', 3000);
      tran.inOutId = this.inOutTypes[tran.inOutType];
      tran.prInTransaction = this.productsInTransaction;
      tran.warehouseId = this.warehouse.id;
      delete tran.inOutType;
      if(this.selectedBill) tran.billRef = this.tranService.afh.doc(`${this.tranService.billCollection}/${this.selectedBillId}`).ref;
      if(this.selectedRem) tran.remRef = this.tranService.afh.doc(`${this.tranService.remCollection}/${this.selectedRemId}`).ref;
      tran.folio = await this.settingsService.getNextFolioAndIncrement('nextIn');
      this.tranService.addTransaction({ ...tran }, TranType.In);
      let odcsToUpdate: {[id: string]: any[]} = {};
      for(let pr of this.productsInTransaction){
        if(!pr.odcId) continue;
        //console.log('Turn of', pr);
        let odcPrIndex = pr.odcIndex;
        //console.log(`Found index ${odcPrIndex}`);
        if(odcPrIndex == -1) continue;
        let odcPr = this.odcs[pr.odcId].prForOrders[odcPrIndex];
        //console.log(`Pr is `, odcPr);
        if(!odcsToUpdate[pr.odcId]) odcsToUpdate[pr.odcId] = [...this.odcs[pr.odcId].prForOrders];
        //console.log(`updates: `, odcsToUpdate[pr.odcId]);
        odcsToUpdate[pr.odcId][odcPrIndex].inWareQuantity = (odcPr.inWareQuantity || 0) + pr.quantity;
        delete odcsToUpdate[pr.odcId][odcPrIndex].moveQuantity;
      }
      for(let odcId in odcsToUpdate){
        //console.log(odcsToUpdate);
        this.odcService.updatePurchaseOrder(odcId, {prForOrders: odcsToUpdate[odcId]})
      }
      
    }
  }
  /* async returnRequested(){
    let requestedIndex = this.settings.folios.nextInRequesteds.indexOf(this.requestedFolio);
    if(requestedIndex > -1){
      this.settings.folios.nextInRequesteds.splice(requestedIndex, 1);
      await this.settingsService.putPayrollSettings(<PayrollId>{folios: this.settings.folios}, '1');
    }
    //this.service.windowReplace('read');
    //window.onbeforeunload = null;
  }
  updateSettings(){
    let requestedIndex = this.settings.folios.nextInRequesteds.indexOf(this.requestedFolio);
    if(requestedIndex > -1){
      this.settings.folios.nextInRequesteds.splice(requestedIndex, 1);
    }
    if(this.requestedFolio > this.settings.folios.nextIn) this.settings.folios.nextIn = this.requestedFolio;
    this.settingsService.putPayrollSettings(this.settings, '1');
  } */

  createForm(){
    this.createInTranForm = this.fb.group({
      inOutType: ['', Validators.required],
      date: [this.today],
      billFolio: '',
      remFolio: '',
      observations: '',
    });
  }
  createTranProductForm(){
    this.tranProductForm = this.fb.group({
      name: ['', Validators.required],
      quantity: ['', [Validators.required, Validators.min(0)]]
    });
  }

  openModalTranProduct(index: number) {
    this.onEdit = index;
    this.tranProductForm.reset();
    this.productError = false;
    if (index > -1) {
      this.tranProductForm.get('quantity').setValue(this.productsInTransaction[index].quantity);
    }
    this.modalActionsTranProduct.emit({ action: 'modal', params: ['open'] });
    if(this.productType == 'compra'){
      this.productsInit = this.prCmpasInit;
    } else{
      this.productsInit = this.prVntasInit;
    }
  }
  closeModalTranProduct(){
    this.tranProductForm.reset();
    this.modalActionsTranProduct.emit({ action: 'modal', params: ['close'] });
  }
  selectPrType(productType: string){
    this.productType = productType;
    this.productsInit = (productType == 'compra') ? this.prCmpasInit : this.prVntasInit;
    this.tranProductForm.get('name').setValue('');
  }

  addPrInTransaction({ value, valid }: { value: any, valid: boolean }) {
      let [productId, collection] = this.productType == 'compra' ? [this.prCmpas[value.name], this.tranService.prCmpaCollection ] : [this.prVntas[value.name], this.tranService.prVntaCollection];
      if(!productId){
        this.productError = true;
        this.tranProductForm.get('name').reset();
      }else{
        let ref = this.tranService.afh.doc(`${collection}/${productId}`).ref;
        this.productsInTransaction.push( <any>{ref, quantity: value.quantity} );
        this.closeModalTranProduct();
      }
  }
  editPrInTransaction({ value, valid }: { value: any, valid: boolean }, index: number){
    this.productsInTransaction[index].quantity = value.quantity;
    this.closeModalTranProduct();
  }
  deletePrInTransaction(index){
    this.productsInTransaction.splice(index,1);
  }

  get today(){
    var today = new Date();
    var dd:string = today.getDate() + '';
    var mm:string = today.getMonth()+ 1 + '';
    var yyyy = today.getFullYear();
    if(+dd<10) dd = '0'+dd;
    if(+mm<10) mm = '0'+mm;
    return yyyy + '-' + mm + '-' + dd;
  }



  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 

  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  modalActionsPrOdc = new EventEmitter<string|MaterializeAction>();
  modalParamsPrOdc = [{dismissible: true}];
  
  productionOrders: any = {};
  odcs: {[id: string]: PurchaseOrderId} = {};
  bills: {[billId: string]: CustomerBillId} = {};
  rems: {[remId: string]: RemissionId} = {};

  get readValid(){ return true; }

  appliesBill: boolean = false;
  appliesRem: boolean = false;

  selectedOdcId: string = '';
  get selectedOdc(): PurchaseOrderId { return this.odcs[this.selectedOdcId] || null }
  selectedBillId: string = '';
  get selectedBill(): CustomerBillId { return this.bills[this.selectedBillId] || null }
  selectedRemId: string = '';
  get selectedRem(): RemissionId { return this.rems[this.selectedRemId] || null }

  currentReadIndex: number;
  currentPrIndex: number;
  rowsRead = [[], [], [], []];
  columnsRead = [
    [
      { title: 'Folio', name: 'name', sort: 'desc' },
      { title: 'Compromiso de entrega', name: 'deliveryDate' },
      { title: 'Cantidad', name: 'quantity' },
      { title: 'Estatus', name: 'status' },
    ],
    [
      {title: 'Folio', name: 'name', sort: 'asc'},
      {title: 'Proveedor', name: 'supplierName'},
      {title: 'Fecha' , name: 'date'},
      {title: 'Proyectos', name: 'odpNames'},
    ],
    [
      {title: 'Folio de factura', name: 'name'},
      {title: 'Cliente', name: 'customerName'},
      {title: 'Fecha', name: 'date'},
      {title: 'Fecha de pago', name: 'payDate'},
      {title: 'Estatus', name: 'statusName'},
    ],
    [
      {title: 'Folio', name: 'name'},
      {title: 'Razón social', name: 'businessName'},
      {title: 'Orden de producción', name: 'odp'},
      {title: 'Dirección de entrega', name: 'addressName'},
      {title: 'Fecha', name: 'date'},
      {title: 'Cantidad', name: 'quantity'},
    ],
  ]

  openModalRead(index: number, prIndex: number = -1) {
    this.currentReadIndex = index;
    this.currentPrIndex = prIndex;
    this.data = this.rowsRead[index];
    
    this.config = this.configs[index];
  
    this.onChangeTable(this.config);
    this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
  }
  closeModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
  }
  selectRead({row}): any{
    if(this.currentReadIndex == 0){
      this.productsInTransaction[this.currentPrIndex].odpId = row.id;
      this.productsInTransaction[this.currentPrIndex].odpName = row.name;
    }else if(this.currentReadIndex == 1){
      this.openModalPrOdc(row.id);
    }else if(this.currentReadIndex == 2){
      this.selectedBillId = row.id;
    }else if(this.currentReadIndex == 3){
      this.selectedRemId = row.id;
    }
    this.closeModalRead();
  }
  unselectRead(){
    if(this.currentReadIndex == 0){
      this.productsInTransaction[this.currentPrIndex].odpId = '';
      this.productsInTransaction[this.currentPrIndex].odpName = '';
    }else if(this.currentReadIndex == 2){
      this.selectedBillId = '';
    }else if(this.currentReadIndex == 3){
      this.selectedRemId = '';
    }
    this.closeModalRead();
  }

  openModalPrOdc(id: string){
    this.selectedOdcId = id;
    this.modalActionsPrOdc.emit({ action: 'modal', params: ['open'] });
  }
  closeModalPrOdc() {
    this.modalActionsPrOdc.emit({ action: 'modal', params: ['close'] });
  }
  touchPrOdc(){
    let index: number = -1;
    for(let pr of this.selectedOdc.prForOrders){
      index++;
      if(!pr.id || isNaN(+pr["moveQuantity"]) || +pr["moveQuantity"] <= 0) continue;
      let collection = this.tranService.prCmpaCollection;
      let productId = pr.id;
      let ref = this.tranService.afh.doc(`${collection}/${productId}`).ref;
      console.log('prId', productId)
      console.log('pr', this.allProducts[productId])
      console.log(this.allProducts)
      this.productsInTransaction.push({
        ref,
        quantity: +pr["moveQuantity"],
        odpId: pr.odpId || '',
        odpName: pr.odpName || '',
        odcId: this.selectedOdcId,
        odcIndex: index,
      } as PrInTransaction)
    }
    this.closeModalPrOdc();
  }


  data:Array<any>;
  rows:Array<any> = [];
  page:number = 1;
  itemsPerPage:number = 5;
  maxSize:number = 5;
  numPages:number = 1;
  length:number = 0;

  config;
  configs:any = this.columnsRead.map(columns => ({
    paging: true,
    sorting: {columns},
    filtering: {filterString: ''}
  }));

  /*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columnsRead[this.currentReadIndex].forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columnsRead[this.currentReadIndex].forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA

}